import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  MenuItem,
  Select,
  TextField,
  Typography,
  Tooltip,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  IconButton,
  Stack,
  Checkbox,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Close as CloseIcon } from '@mui/icons-material';
import ChevronLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRight from '@mui/icons-material/KeyboardDoubleArrowRight';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));



const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SendEmail = () => {
  const theme = useTheme();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [batch, setBatch] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedStudents, setSelectedStudents] = useState([]);

  // Static data for Batch dropdown
  const staticBatchData = [
    { id: 1, name: 'Batch 1' },
    { id: 2, name: 'Batch 2' },
    { id: 3, name: 'Batch 3' },
  ];

  // Static data for candidates
  const [candidates, setCandidates] = useState([
    {
      id: 1,
      admissionNo: 'ADM001',
      candidateName: 'John Doe',
      mobileNo: '1234567890',
      email: 'john.doe@example.com',
      address: '123 Main St, City',
      batch: 'Batch 1',
    },
    {
      id: 2,
      admissionNo: 'ADM002',
      candidateName: 'Jane Smith',
      mobileNo: '9876543210',
      email: 'jane.smith@example.com',
      address: '456 Park Ave, Town',
      batch: 'Batch 2',
    },
    {
      id: 3,
      admissionNo: 'ADM003',
      candidateName: 'Alice Johnson',
      mobileNo: '5551234567',
      email: 'alice.johnson@example.com',
      address: '789 Broadway, Village',
      batch: 'Batch 1',
    },
  ]);

  const handleSelectStudent = (studentId) => {
    setSelectedStudents(prev =>
      prev.includes(studentId)
        ? prev.filter(id => id !== studentId)
        : [...prev, studentId]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedStudents(candidates.map(student => student.id));
    } else {
      setSelectedStudents([]);
    }
  };

  const handleSend = (e) => {
    e.preventDefault();
    if (selectedStudents.length === 0) {
      setSnackbarMessage('Please select at least one student');
      setOpenSnackbar(true);
      setSnackbarSeverity('error')
      return;
    }
    if (subject && message && batch) {
       setSnackbarMessage('Send Email successfully!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
    } else {
      setSnackbarMessage('Please fill all required fields');
      setOpenSnackbar(true);
      setSnackbarSeverity('error')
    }
  };

  const handleCancel = () => {
    setSubject('');
    setMessage('');
    setBatch('');
    setSelectedStudents([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const filteredCandidates = candidates.filter(candidate =>
    candidate.admissionNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate.candidateName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate.mobileNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate.batch.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedCandidates = filteredCandidates.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const isFormFilled = subject && message && batch;

  return (
    <Container sx={{ maxWidth: '100%', boxSizing: 'border-box' }}>
      {/* Form Section */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:'flex-end',
          mb:1
        }}
      >
        <IconButton
          onClick={() => setShowUserGuideModal(true)}
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            minWidth: 0, // Remove MUI's default padding
          }}
        >
          <InfoOutlineIcon sx={{ fontSize: 30 }} />
        </IconButton>
      </Box>
      <Box
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <TextField
          label="Subject"
          variant="outlined"
          fullWidth
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          sx={{
            my: 2,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.text.primary,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
            },
            '& .MuiInputLabel-root': {
              color: theme.palette.text.primary,
            },
          }}
        />

        <TextField
          label="Message"
          variant="outlined"
          fullWidth
          multiline
          rows={6}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          sx={{
            my: 2,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.text.primary,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
            },
            '& .MuiInputLabel-root': {
              color: theme.palette.text.primary,
            },
          }}
        />

        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel id="batch-label" sx={{ color: theme.palette.text.primary }}>
            Batch
          </InputLabel>
          <Select
            labelId="batch-label"
            id="batch"
            value={batch}
            label="Batch"
            onChange={(e) => setBatch(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.text.primary,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
              },
            }}
          >
            <MenuItem value="">
              <em>Select Batch</em>
            </MenuItem>
            {staticBatchData.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Tooltip
            title={
              selectedStudents.length === 0 ? "Select at least one student" :
                !subject ? "Enter Subject" :
                  !message ? "Enter Message" :
                    !batch ? "Select Batch" : ""
            }
            arrow
          >
            <span>
              <Button
                variant="contained"
                onClick={handleSend}
                sx={{
                  mr: 2,
                  width: '150px',
                  height: '50px',
                  borderRadius: '10px',
                  padding: '10px 0',
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.dark },
                }}
                disabled={!isFormFilled || selectedStudents.length === 0}
              >
                SEND EMAIL
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
            sx={{
              width: '100px',
              height: '50px',
              borderRadius: '10px',
              padding: '10px 0',
              fontWeight: 'bold',
            }}
          >
            CANCEL
          </Button>
        </Box>
      </Box>

      {/* Table Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, p: 2, boxShadow: 'none', maxWidth: '100%', boxSizing: 'border-box' }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 2, }}>
          Candidates
        </Typography>
      </Box>

      <Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white'
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                    <Checkbox
                      checked={selectedStudents.length === candidates.length && candidates.length > 0}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Admission No.</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Candidate Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Mobile No.</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Email</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Address</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Batch</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedCandidates.map((candidate, index) => (
                  <TableRow
                    key={candidate.id}
                    sx={{
                      backgroundColor: candidate.id % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <TableCell sx={{ fontSize: '1rem' }}>
                      {(page - 1) * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>
                      <Checkbox
                        checked={selectedStudents.includes(candidate.id)}
                        onChange={() => handleSelectStudent(candidate.id)}
                        sx={{
                          color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary,
                          '&.Mui-checked': { color: theme.palette.primary.main },
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{candidate.admissionNo}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{candidate.candidateName}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{candidate.mobileNo}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{candidate.email}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{candidate.address}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{candidate.batch}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      {/* Pagination */}
      {filteredCandidates.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.primary.main}
          >
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredCandidates.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredCandidates.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredCandidates.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={(e) => {
                  const newRowsPerPage = Number(e.target.value);
                  setRowsPerPage(newRowsPerPage);
                  handleChangePage(null, 1);
                }}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Email Sent ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Email Sent Successfully to {selectedStudents.length} student(s)
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  setSubject('');
                  setMessage('');
                  setBatch('');
                  setSelectedStudents([]);
                }}
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: '10px',
                  height: '40px',
                  padding: '0 20px',
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.dark },
                }}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Snackbar for errors */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="error" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal
      open={showUserGuideModal}
      onClose={() => setShowUserGuideModal(false)}
      BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Send Email - User Guide
          </Typography>
          <IconButton
            onClick={() => setShowUserGuideModal(false)}
            sx={{ color: '#fff', position: 'absolute', right: 14 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Scrollable Content */}
        <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
          {/* Section 1: Send Email */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
          >
            ➤ Follow these steps to send an email:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              Enter the <strong>Subject</strong> in the provided text field.
            </li>
            <li>
              Enter the <strong>Message</strong> in the provided multiline text field.
            </li>
            <li>
              Select a <strong>Batch</strong> from the dropdown menu.
            </li>
            <li>
              Select one or more students from the table below by checking the corresponding checkboxes.
            </li>
            <li>
              Before clicking on "SEND EMAIL", button First review all entered information to ensure accuracy.
            </li>
            <li>
              Then click the <strong>"SEND EMAIL"</strong> button to send the email. A success message will confirm the action and clear the form.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Subject, Message, Batch, and at least one selected student are required fields.
          </Typography>

          {/* Section 2: Cancel Form */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to cancel the form:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              Click the <strong>"CANCEL"</strong> button to clear all form fields (Subject, Message, Batch) and deselect all students.
            </li>
            <li>
              This will restore the form to its initial state.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Canceling the form does not save any entered data.
          </Typography>

          {/* Section 3: Select Students */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to select students:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              Check the box in the table header to select all students on the current page.
            </li>
            <li>
              Check individual student checkboxes in the table to select specific students.
            </li>
            <li>
              Selected students will receive the email when the <strong>"SEND EMAIL"</strong> button is clicked.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: At least one student must be selected to send the email.
          </Typography>

          {/* Section 4: Pagination */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to navigate the candidates list:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              Use the pagination controls at the bottom to navigate through pages of candidates.
            </li>
            <li>
              Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
            </li>
            <li>
              Select a specific page number by clicking on it.
            </li>
            <li>
              Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The table displays only the selected number of rows per page.
          </Typography>

          {/* Bottom Close Button */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            {/* <Button
              variant="contained"
              onClick={() => setShowUserGuideModal(false)}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
                fontWeight: 'bold',
                padding: '8px 24px',
                borderRadius: '8px',
              }}
            >
              Close
            </Button> */}
          </Box>
        </CustomTableScrollbar>
      </Box>
    </Modal>
    </Container>
  );
};

export default SendEmail;
